/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
// eslint-disable-next-line no-unused-vars
import {
    VoteOption,
    VoteOptionFromJSON,
    VoteOptionToJSON,
} from './';

/**
 * 
 * @export
 * @interface IdeaVoteUpdateAdmin
 */
export interface IdeaVoteUpdateAdmin {
    /**
     * 
     * @type {VoteOption}
     * @memberof IdeaVoteUpdateAdmin
     */
    vote: VoteOption;
    /**
     * User ID on whose behalf to vote
     * @type {string}
     * @memberof IdeaVoteUpdateAdmin
     */
    voterUserId: string;
}

export function IdeaVoteUpdateAdminFromJSON(json: any): IdeaVoteUpdateAdmin {
    return {
        
        'vote': VoteOptionFromJSON(json['vote']),
        'voterUserId': json['voterUserId'],
    };
}

export function IdeaVoteUpdateAdminToJSON(value?: IdeaVoteUpdateAdmin): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        
        'vote': VoteOptionToJSON(value.vote),
        'voterUserId': value.voterUserId,
    };
}


